module.exports = __webpack_public_path__ + "static/media/hot63.12f318f2.jpg";